import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient, removeHeaderToken } from "../config/apiClient";
import { API } from "../config/apiConfig";
import { LoginResponseNetType, RefreshTokenBodyNetType } from "./NetTypes";

export async function refreshRequest({ refreshToken }: RefreshTokenBodyNetType) {
	removeHeaderToken();
	return await apiClient.post(API.AUTH.REFRESH_TOKEN, { refreshToken }).then((res) => res.data);
}

export function useRefreshToken(
	onSuccess: (data: LoginResponseNetType) => void,
	onError: () => void
) {
	return useMutation<LoginResponseNetType, AxiosError, RefreshTokenBodyNetType>({
		mutationFn: ({ refreshToken }: RefreshTokenBodyNetType) => {
			return refreshRequest({ refreshToken });
		},
		onSuccess,
		onError
	});
}
